import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const OpportunityCardSkeleton = () => {
  return (
    <div className="bg-white dark:bg-gray-900 rounded-lg p-5 shadow-sm border border-gray-200 dark:border-gray-700 min-h-[180px] flex flex-col">
      <div className="flex-1">
        {/* Card number */}
        <div className="flex items-center gap-2 mb-3">
          <Skeleton className="w-6 h-6 rounded-[4px]" />
        </div>

        {/* Title */}
        <div className="mb-3">
          <Skeleton className="h-[18px] w-3/4 mb-1" />
        </div>

        {/* Description - 2 lines */}
        <div className="mb-4 space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>

        {/* Metrics section */}
        <div className="flex items-center justify-between mt-auto">
          <div className="flex items-center justify-between w-full">
            {/* Data points and percentage */}
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-12" />
              <Skeleton className="h-4 w-8" />
              <Skeleton className="h-4 w-6" />
            </div>
            {/* Thumbs feedback */}
            <div className="flex items-center gap-1">
              <Skeleton className="w-6 h-6 rounded" />
              <Skeleton className="w-6 h-6 rounded" />
            </div>
          </div>
        </div>
      </div>

      {/* Action buttons */}
      <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-24 rounded-lg" />
          <Skeleton className="h-8 w-16 rounded-lg" />
        </div>
      </div>
    </div>
  )
}

export default OpportunityCardSkeleton
